import { render, staticRenderFns } from "./PasswordForgot.vue?vue&type=template&id=20788450&scoped=true"
import script from "./PasswordForgot.vue?vue&type=script&lang=js"
export * from "./PasswordForgot.vue?vue&type=script&lang=js"
import style0 from "./PasswordForgot.vue?vue&type=style&index=0&id=20788450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20788450",
  null
  
)

export default component.exports